import { render, staticRenderFns } from "./series_long.vue?vue&type=template&id=2810ce78"
import script from "./series_long.vue?vue&type=script&lang=js"
export * from "./series_long.vue?vue&type=script&lang=js"
import style0 from "./series_long.vue?vue&type=style&index=0&id=2810ce78&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports